var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { space, color, fontSize, compose, } from 'styled-system';
var _Icon = styled(function (_a) {
    var color = _a.color, fontSize = _a.fontSize, opacity = _a.opacity, props = __rest(_a, ["color", "fontSize", "opacity"]);
    return (React.createElement(FontAwesomeIcon, __assign({}, props)));
})(compose(space, color, fontSize));
export function Icon(_a) {
    var icon = _a.icon, props = __rest(_a, ["icon"]);
    var iconWithStyle = typeof icon === 'string' ? ['fal', icon] : icon;
    return React.createElement(_Icon, __assign({ icon: iconWithStyle, style: { width: '1em' } }, props));
}
Icon.defaultProps = {
    color: 'inherit',
    fontSize: 'inherit',
};
export default React.memo(Icon);
